// common/services/player/updateFamilyContact.ts
import req from '../../api/request'
import { familyContactUpdatePath, type FamilyScope } from './familyScope'

export type UpdateFamilyContactInput = {
  /** Player whose family the contact belongs to. */
  playerId: string
  /** The contact being edited. */
  contactId: string
  /** Given name for the contact. */
  name_first: string
  /** Family name for the contact. */
  name_last: string
  email: string
  /** E.164 phone number (e.g. '+14165550123'). Optional per the design. */
  phone_number?: string | null
  /** BE relationship type id (RelationshipType). Null clears/omits it. */
  relationship_type_id?: number | null
  /** Whether the contact gets administrative access to the player. */
  is_primary?: boolean
  /** Which backend routes to use. Omitted → self-scoped ('me'). */
  scope?: FamilyScope
}

export type UpdateFamilyContactResponse = {
  id?: string
  status?: 'updated' | 'pending'
} & Record<string, unknown>

/**
 * PUT an existing family contact's profile (route chosen by `scope`). Body
 * mirrors inviteFamilyContact (minus the contactId itself, which is in the
 * path).
 */
export const updateFamilyContact = async (
  input: UpdateFamilyContactInput
): Promise<UpdateFamilyContactResponse> => {
  const { playerId, contactId, scope, ...body } = input
  const { data } = await req(
    familyContactUpdatePath(playerId, contactId, scope),
    { method: 'PUT', body: JSON.stringify(body) }
  )
  return data as UpdateFamilyContactResponse
}
